import React, { useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCopy,
    faTimes
} from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from '../Common/ThemeProvider';

const TermsAndConditions = ({ selection, Terms, AddNewRow, RemoveRow, UpdateRow, onCloseTerms }) => {

    const { CurrentTheme } = useContext(ThemeContext);

    const AddTerms = () => {
        AddNewRow();
    };

    const RemoveTerms = (content, index) => {
        RemoveRow(content, index);
    };

    const onTextChange = (e) => {
        let data = document.getElementById(e.target.id);
        if (data !== null) {
            data.setAttribute('placeholder', e.target.value);
        }
    };

    const OnSave = () => {
        let data = document.querySelectorAll(".termsInfo");
        if (data !== null) {
            var textareaList = [];
            data.forEach(control => {
                if (control.placeholder.trim() !== "") {
                    textareaList.push(control.placeholder.trim());
                }
            });

            var completeData = textareaList.join('|');
            if (completeData !== "" || data.length === 0) {
                onCloseTerms();
                UpdateRow({ Name: selection, Data: completeData })
            }
        }
    }

    const OnCopy = (Id) => {
        var textArea = document.getElementById(Id);
        if (textArea !== null && textArea.placeholder !== "") {
            var text = document.getElementById("copyText");
            if (text !== null) {
                text.value = textArea.placeholder;
                text.select();
                document.execCommand("copy");
            }
        }
    };

    return (
        <div>
            <div>
                <div className="row" style={{
                    height: "60vh", overflow: "auto", overflowX: "hidden",
                    paddingRight: "10px", scrollbarColor: "#005582 transparent", marginBottom: "10px"
                }}>
                    <table className="table">
                        <tbody>
                            {(Terms && Terms !== "") ? Terms.split('|').map((terms, index) => (
                                <tr key={index}>
                                    <td>
                                        <div className="col-md-12 col-12" style={{ display: "flex", padding: "0" }}>
                                            <div className={`${CurrentTheme}-noborder arrow-style`}>{index + 1}</div>
                                            <textarea id={`${index}_terms`} onChange={onTextChange} rows="1" style={{ resize: "none", paddingRight: "45px" }} className="forms-control text-left-border-style textcontrol termsInfo" placeholder={terms}></textarea>
                                            <div style={{ position: "relative", right: "50px", margin: "auto" }}>
                                                <FontAwesomeIcon style={{ color: "red" }} onClick={() => RemoveTerms(terms, index)} className="font-size2rem padding-topLeft hover-style" icon={faTimes}></FontAwesomeIcon>
                                            </div>
                                            <div title={`Copy Point ${index + 1}`} style={{ margin: "auto" }}>
                                                <FontAwesomeIcon onClick={() => OnCopy(`${index}_terms`)} className="font-size15rem hover-style" icon={faCopy}></FontAwesomeIcon>
                                            </div>
                                            <input type="text" id="copyText" style={{ border: "none", height: "0", width: "0" }}></input>
                                        </div>
                                    </td>
                                </tr>
                            )) : null}</tbody>
                    </table>
                </div>
                <div style={{ textAlign: "right" }}>
                    <button className="btn btn-General" onClick={AddTerms}>Add New</button>
                    <button className="btn btn-General" onClick={OnSave}>Update</button>
                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;